







































import { index, destroy, qrcode, exportDramas, authUrl, submitReview } from '@/api/stores'
import { Component, Vue } from 'vue-property-decorator'
import { clipboardCopy } from '@/utils/copy.ts'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'merchant',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'thumbnail', label: 'T', slot: true, width: 60 },
      { prop: 'name', label: '名称', width: 200 },
      { prop: 'contact_mobile', label: '电话', width: 100 },
      { prop: 'payment', label: '支付', width: 80, slot: true },
      { prop: 'purchased', label: '有效期', width: 200, slot: true },
      { prop: 'current_money', label: '余额', width: 100 },
      { prop: 'users_count', label: '用户', width: 80 },
      { prop: 'impresarios_count', label: 'DM', width: 80 },
      { prop: 'dramas_count', label: '剧本', width: 80 },
      { prop: 'merchant', label: '创建者', width: 150, slot: true },
      { prop: 'address', label: '地址' },
      { prop: 'created_at', label: '注册时间', width: 150 }
    ]
  }

  async destroyRow (row: Record<string, any>) {
    this.$ask(async () => {
      await destroy(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been deleted')
    })
  }

  async downMiniProgramQrCode (row: Record<string, any>) {
    this.$message.info('小程序码生成中...')
    const axiosResponse: Record<string, any> = await qrcode(row.id)
    window.open(axiosResponse.data.url)
  }

  async downDramas (row: Record<string, any>) {
    this.$message.info('剧本导出中...')
    const axiosResponse: Record<string, any> = await exportDramas(row.id)
    console.log(axiosResponse.data)
    const blob = axiosResponse.data
    // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = '剧本.xlsx'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
  }

  async onTapCopyAuthUrl (row: Record<string, any>) {
    this.$message.info('生成授权链接中...')
    const axiosResponse: Record<string, any> = await authUrl(row.id)
    await clipboardCopy(axiosResponse.data.url)
    this.$message.success('授权链接已复制到剪切板')
  }

  async onTapSubmitReview (row: Record<string, any>) {
    this.$message.info('提交审核中...')
    await submitReview(row.id)
    this.$message.success('已加入待审核队列')
  }
}
